module.exports = __webpack_public_path__ + "static/img/so3_5.7ed5b36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_5.jpg
// module id = K/4i
// module chunks = 11